import PaginationSchema, { PaginationJSON, PaginationParametersParams } from "./_schema/pagination-parameters-schema";

export default class PaginationParameters {
  public static readonly DEFAULT_PAGE_INDEX = 0;
  public static readonly DEFAULT_PAGE_SIZE = 25;

  public static readonly DEFAULT = new PaginationParameters({
    pageIndex: PaginationParameters.DEFAULT_PAGE_INDEX,
    pageSize: PaginationParameters.DEFAULT_PAGE_SIZE,
  });

  public static create(values?: { pageIndex: number; pageSize: number }): PaginationParameters {
    const defaultValues = { pageIndex: 0, pageSize: 25 };
    const parsed: PaginationParametersParams = PaginationSchema.validate(values ?? defaultValues);
    return new PaginationParameters(parsed);
  }

  static fromJSON(pagination: PaginationJSON | undefined): PaginationParameters | undefined {
    if (!pagination) return undefined;
    return new PaginationParameters(PaginationSchema.deserialize(pagination));
  }
  public static fromSearchParams(
    searchParams: URLSearchParams,
    options?: {
      pageIndexParamName: string;
      pageSizeParamName: string;
    },
  ): PaginationParameters {
    const opts = options ?? {
      pageIndexParamName: "pageIndex",
      pageSizeParamName: "pageSize",
    };
    const pageIndex = Number.parseInt(searchParams.get(opts.pageIndexParamName) ?? "0") || 0;
    const pageSize = Number.parseInt(searchParams.get(opts.pageSizeParamName) ?? "25") || 25;

    return new PaginationParameters({
      pageIndex: Math.max(0, pageIndex),
      pageSize: Math.min(100, Math.max(1, pageSize)),
    });
  }

  public readonly pageIndex: number;
  public readonly pageSize: number;

  public get searchParams(): URLSearchParams {
    return new URLSearchParams({
      pageIndex: this.pageIndex?.toString() ?? "0",
      pageSize: this.pageSize?.toString() ?? "25",
    });
  }

  public constructor(values?: { pageIndex: number; pageSize: number }) {
    this.pageIndex = values?.pageIndex ?? PaginationParameters.DEFAULT_PAGE_INDEX;
    this.pageSize = values?.pageSize ?? PaginationParameters.DEFAULT_PAGE_SIZE;
  }

  public valueOf(): string {
    return this.searchParams.toString();
  }
  public isEqualTo(other: PaginationParameters | null | undefined): boolean {
    if (!other) return false;
    return this.pageIndex === other.pageIndex && this.pageSize === other.pageSize;
  }
  public toString(): string {
    return this.searchParams.toString();
  }
  public toJSON(): PaginationJSON {
    return PaginationSchema.serialize(this);
  }
}
